module.exports = __webpack_public_path__ + "img/product3.84e56da4.png";